<template>
  <!-- ======= SectionTwo Begins here =======  :pagination="{clickable: true}"-->
<section id="services" class="services sectiontwo" data-aos="fade-up" :class="{allcardsextsection: allcardsexttheme === 'allcardsextsection'}">
<div class="container sectioncontrol" data-aos="fade-up">
  <h3 style="text-align: center; margin-bottom: 30px; color: red; font-size: 40px;">{{ cvdesc }}</h3>
  <div :class="`row`">
    <div :class="`col-xs-12 col-sm-12 col-md-${cardnumber} g-4 sectiontwocol8`"  v-for="photo in valuesphotos" :key="photo">
      <div class="card w-100 h-100 servicescards" style="border-style: none;">
        <router-link :to="{path: photo.cardlink}" class="cardref">
        <div style="background-color: whitesmoke;">
          <img :src="`${myPicUrl}${photo.cardimage}`"  class="card-img-top iconsize" alt="" data-aos="fade-up" data-aos-duration="100" data-aos-delay="100">
        </div>
        <div class="card-body" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">
          <h5 class="card-title" v-html="photo.carddesc"></h5>
          <p class="card-text"></p>
        </div>
      </router-link>
      </div>
    </div>
  </div>
  <div class="sectiontwolinkname"><a></a></div>
</div>
</section><!-- End Services Section -->
</template>

<script>
require('@/globalDeclare.js');
export default {
props: ['cvdesc', 'valuesphotos', 'cvpurposevaluelinkname', 'cvlink', 'allcardsexttheme', 'cvvisibility',
'cardnumber', 'cardwidth'],
data() {
return {
myPicUrl: ''
}
},

mounted() {
this.myPicUrl = myUrlPath
}
}
</script>

<style scoped>
.sectioncontrol{
opacity: .9;
padding-top: 100px;
padding-bottom: 100px;
height: auto;
text-align: center;
}
.sectiontwolinkname {
text-align: right; 
padding-top: 50px;
height: 50px;
font-size: 19px;
background: -webkit-linear-gradient(#003, maroon);
-webkit-background-clip: text;

font-weight: bold;
}
.sectiontwopurpose{
text-align: center; 
margin-bottom: 30px; 
height: 50px;
font-size: 26px;
background: -webkit-linear-gradient(#003, maroon);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
font-weight: bold;
}
.sectiontwo {
margin-bottom: 100px;
background-color: #f9ebea;

}
.servicescards {
background-color: #003;
color: white;
text-align: center;
}
.iconsize {
width: 100px;
}
.card-title{
color: white;
text-decoration: none;
}
.cardref{
text-decoration: none;
}
/*===================MEDIA SCREENS TAMPLATES===============*/
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
.sectiontwo {
margin-bottom: 100px;
background-color: #f9ebea;
margin-top: -20px;
}
.sectiontwopurpose{
margin-top: -30px;
}
.card-title{
width: 100%;
font-size: 18px;
}
.iconsize{
  width: 50%;
  padding: 10px;
  border-radius: 6px;
}
.sectioncontrol {
  padding-left: 60px;
  padding-right: 60px;
}
.sectiontwocol8 {
  padding-top: 30px;
}

/*
.col {
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 50px;
}*/
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .iconsize{
    width: 50%;
    padding: 10px;
  }
  .sectioncontrol {
    padding-left: 80px;
    padding-right: 80px;
  }
  .sectiontwocol8 {
    padding-top: 30px;
  }
  /*
  .col {
    padding-left: 60px;
    padding-right: 60px;
    padding-top: 50px;
  }
  */
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .iconsize{
    width: 70%;
    padding: 10px;
  }
  /*
  .col {
    padding-left: 160px;
    padding-right: 160px;
    width: 100%;
  }
  .card {
    width: 100%;
  }
  */


}

/* Medium devices (landscape tablets, 768px and up)
@media only screen and (min-width: 800px) {
.card-title {
  font-size: 10px;
}
} */

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  /*
  .col {
    padding-left: 160px;
    padding-right: 160px;
    width: 100%;
  }*/
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {

} 
</style>

